// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/easteregg/fonts/LDFComicSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./components/easteregg/fonts/SmileySans-Oblique.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: "Comic Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Smiley Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
:root {
  --site-font-stack: "Comic Sans", "Smiley Sans", Arial, sans-serif;
}
html,
body,
#app {
  min-height: 100%;
  margin: 0;
}
body {
  overflow-x: hidden;
  background: #000;
  color: #fff;
  font-family: var(--site-font-stack);
}
* {
  box-sizing: border-box;
}
button,
input,
textarea,
select {
  font: inherit;
}
a {
  color: inherit;
  text-decoration: none;
}
.app-shell {
  min-height: 100vh;
  background: var(--app-random-bg, #000);
  font-family: var(--site-font-stack);
  transition: background-color 0.25s ease;
}
.app-route-stage {
  padding-bottom: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":";AAsCA;EACE,yBAAyB;EACzB,+DAA4E;AAC9E;AAEA;EACE,0BAA0B;EAC1B,+DAAkF;AACpF;AAEA;EACE,iEAAiE;AACnE;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;AACX;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mCAAmC;AACrC;AAEA;EACE,sBAAsB;AACxB;AAEA;;;;EAIE,aAAa;AACf;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,uCAAuC;AACzC;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["<template>\n  <div class=\"app-shell\">\n    <SiteNavigation />\n    <main class=\"app-route-stage\">\n      <RouterView />\n    </main>\n  </div>\n</template>\n\n<script setup>\nimport { onBeforeUnmount, watch } from \"vue\";\nimport { useRoute } from \"vue-router\";\nimport SiteNavigation from \"@/components/SiteNavigation.vue\";\n\nconst route = useRoute();\nconst randomColors = [\"#0F0\", \"#F00\", \"#00F\", \"#0FF\", \"#F0F\", \"#FF0\"];\n\nfunction applyRandomBackground() {\n  const color = randomColors[Math.floor(Math.random() * randomColors.length)];\n  document.documentElement.style.setProperty(\"--app-random-bg\", color);\n  document.body.style.backgroundColor = color;\n}\n\nwatch(\n  () => route.fullPath,\n  () => {\n    applyRandomBackground();\n  },\n  { immediate: true }\n);\n\nonBeforeUnmount(() => {\n  document.documentElement.style.removeProperty(\"--app-random-bg\");\n  document.body.style.backgroundColor = \"#000\";\n});\n</script>\n\n<style>\n@font-face {\n  font-family: \"Comic Sans\";\n  src: url(\"./components/easteregg/fonts/LDFComicSans.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Smiley Sans\";\n  src: url(\"./components/easteregg/fonts/SmileySans-Oblique.ttf\") format(\"truetype\");\n}\n\n:root {\n  --site-font-stack: \"Comic Sans\", \"Smiley Sans\", Arial, sans-serif;\n}\n\nhtml,\nbody,\n#app {\n  min-height: 100%;\n  margin: 0;\n}\n\nbody {\n  overflow-x: hidden;\n  background: #000;\n  color: #fff;\n  font-family: var(--site-font-stack);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font: inherit;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n.app-shell {\n  min-height: 100vh;\n  background: var(--app-random-bg, #000);\n  font-family: var(--site-font-stack);\n  transition: background-color 0.25s ease;\n}\n\n.app-route-stage {\n  padding-bottom: 40px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
